///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const UploadIcon = ({
  className,
  height,
  fill,
  title = messages.upload.defaultMessage,
  width
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 12 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="upload-icon">{title}</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="REFERENCE:-Sales-Owned-Bid-Page"
        transform="translate(-1164.000000, -415.000000)"
      >
        <g
          id="Bid-Page/Attachments/Card"
          transform="translate(758.000000, 397.000000)"
        >
          <g id="Icon/Upload" transform="translate(404.000000, 16.000000)">
            <g id="arrow_downward-24px">
              <polygon id="Path" points="0 0 16 0 16 16 0 16"></polygon>
              <polygon
                id="Path"
                fill={fill}
                fillRule="nonzero"
                transform="translate(8.000000, 7.000000) rotate(-180.000000) translate(-8.000000, -7.000000) "
                points="13 7 12.11875 6.11875 8.625 9.60625 8.625 2 7.375 2 7.375 9.60625 3.8875 6.1125 3 7 8 12"
              ></polygon>
            </g>
            <rect
              id="Rectangle"
              fill={fill}
              x="2"
              y="13"
              width="12"
              height="1.33"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default UploadIcon;
